import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RebusApp } from './app.component';
import { IonicApp, IonicModule } from 'ionic-angular';
import { AngularFireModule, AuthProviders, AuthMethods } from 'angularfire2';
import { IonicStorageModule } from '@ionic/storage';
import { AgmCoreModule } from 'angular2-google-maps/core';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { Ionic2RatingModule } from 'ionic2-rating';
import { Http, HttpModule, JsonpModule } from '@angular/http';
import { ChartsModule } from 'ng2-charts/ng2-charts';
// Pages
import { ClientPage } from '../pages/client/client';
import { RoomPage } from '../pages/room/room';
import { HomePage } from '../pages/home/home';
import { EventPage } from '../pages/event/event';
import { LandingPage } from '../pages/landing/landing';
import { LoginPage } from '../pages/login/login';
import { EventNotesPage } from '../pages/event-notes/event-notes';
import { EventNotePage } from '../pages/event-note/event-note';
import { EventSpeakerPage } from '../pages/event-speaker/event-speaker';
import { EventDiaryPage } from '../pages/event-diary/event-diary';
import { EventQuestionsPage } from '../pages/event-questions/event-questions';
import { EventOpinometerPage } from '../pages/event-opinometer/event-opinometer';
import { EventCommentPage } from '../pages/event-comment/event-comment';
import { EventResourcePage } from '../pages/event-resource/event-resource';
import { EventProfilePage } from '../pages/event-profile/event-profile';
import { UserRegisterPage } from '../pages/user-register/user-register';
import { UserEditPage } from '../pages/user-edit/user-edit';
import { EventReservePage } from '../pages/event-reserve/event-reserve';
import { EventReserveView } from '../pages/event-reserve-view/event-reserve-view';
import { EventFavoritePage } from '../pages/event-favorite/event-favorite';
import { NetworkProfilePage } from '../pages/network-profile/network-profile';
import { NetworkContacts } from '../pages/network-contacts/network-contacts';
import { NetworkMessage } from '../pages/network-message/network-message';
import { FacebookPage } from '../pages/event-social/facebook/facebook';
import { TwitterPage } from '../pages/event-social/twitter/twitter';
import { InstagramPage } from '../pages/event-social/instagram/instagram';
import { YoutubePage } from '../pages/event-social/youtube/youtube';
import { EventProfileReserves } from '../pages/event-profile-reserves/event-profile-reserves';
import { EventOpinometerView } from '../pages/event-opinometer-view/event-opinometer-view';
import { Splash } from '../pages/splash/splash';
import { EventCatalogs } from '../pages/event-catalogs/event-catalogs';
import { Catalog } from '../pages/event-catalogs/catalog/catalog';
import { EventCart } from '../pages/event-cart/event-cart';
import { SelectEvent } from '../pages/select-event/select-event';
import { EventCatalogsPayment } from '../pages/event-catalogs-payment/event-catalogs-payment';
import { Payment } from '../pages/event-catalogs-payment/payment/payment';
import { EventStreaming } from '../pages/event-streaming/event-streaming';
import { EventQuestionView } from '../pages/event-question-view/event-question-view';
import { EventStands } from '../pages/event-stands/event-stands';
// Providers
import { AuthData } from '../providers/auth';
import { ClientData } from '../providers/client';
import { EventData } from '../providers/event';
import { NotesData } from '../providers/notes';
import { QuestionsData } from '../providers/questions';
import { DiaryData } from '../providers/diary';
import { UserData } from '../providers/user';
import { Utilities } from '../providers/utilities';
import { Tracking } from '../providers/tracking';
import { Database } from '../providers/database';
import { StorageFb } from '../providers/storage';
import { SpeakerData } from '../providers/speaker';
import { ReserveData } from '../providers/reserve';
import { Translate } from '../providers/translate';
// Components
import { EventDiaryComponent } from '../components/event-diary/event-diary';
import { EventNowComponent } from '../components/event-now/event-now';
import { EventSponsorComponent } from '../components/event-sponsor/event-sponsor';
import { EventSpeakerComponent } from '../components/event-speaker/event-speaker';
import { EventMessageComponent } from '../components/event-message/event-message';
import { EventEmbedComponent } from '../components/event-embed/event-embed';
import { EventMapComponent } from '../components/event-map/event-map';
import { EventNetworkingComponent } from '../components/event-networking/event-networking';
import { EventCatalogComponent } from '../components/event-catalog/event-catalog';
import { EventSocialComponent } from '../components/event-social/event-social';
import { EventStreamingComponent } from '../components/event-streaming/event-streaming';
import { SocialLoginComponent } from '../components/social-login/social-login';
import { UserRegisterComponent } from '../components/user-register/user-register';
import { Paymentez } from '../components/payment-methods/paymentez/paymentez';
import { ProgressBar } from '../components/progress-bar/progress-bar';
import { EventActivity } from '../components/event-activity/event-activity';
import { EventShowCaseMapComponent } from './../components/event-show-case-map/event-show-case-map';
// Pipes
import { GroupByPipe } from '../pipes/group-by';
import { OrderByPipe } from '../pipes/order-by';
import { sanitizeHtmlPipe } from '../pipes/sanitize-html';
import { TranslatePipe } from '../pipes/translate';
import { hackPipe } from '../pipes/hack';
import { languagesPipe } from '../pipes/languages';
import { TruncatePipe } from '../pipes/truncate';

export const firebaseGlobalConfig = {
  apiKey: "AIzaSyC2R0KexmCrEQFnUKiJ_y8WdBo-NJ2-MrY",
  authDomain: "bbdd-appsiste.firebaseapp.com",
  databaseURL: "https://bbdd-appsiste.firebaseio.com",
  projectId: "bbdd-appsiste",
  storageBucket: "bbdd-appsiste.appspot.com",
  messagingSenderId: "740445529883"
};

export function createTranslateLoader(http: Http) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

const FirebaseAuthConfig = {
  provider: AuthProviders.Password,
  method: AuthMethods.Password
};

const PAGES_COMPONENTS = [
  // Pages
  ClientPage,
  RoomPage,
  HomePage,
  LandingPage,
  EventPage,
  LoginPage,
  EventNotesPage,
  EventNotePage,
  EventSpeakerPage,
  EventDiaryPage,
  EventQuestionsPage,
  EventOpinometerPage,
  EventCommentPage,
  EventResourcePage,
  EventProfilePage,
  UserRegisterPage,
  UserEditPage,
  EventReservePage,
  EventReserveView,
  EventFavoritePage,
  NetworkProfilePage,
  NetworkContacts,
  NetworkMessage,
  FacebookPage,
  TwitterPage,
  InstagramPage,
  YoutubePage,
  EventProfileReserves,
  EventOpinometerView,
  Splash,
  EventCatalogs,
  Catalog,
  SelectEvent,
  EventCart,
  EventCatalogsPayment,
  Payment,
  EventStreaming,
  EventQuestionView,
  EventStands,
  // Components
  EventDiaryComponent,
  EventNowComponent,
  EventSponsorComponent,
  EventSpeakerComponent,
  EventMessageComponent,
  EventEmbedComponent,
  EventMapComponent,
  EventNetworkingComponent,
  EventCatalogComponent,
  EventSocialComponent,
  EventStreamingComponent,
  SocialLoginComponent,
  UserRegisterComponent,
  Paymentez,
  ProgressBar,
  EventActivity,
  EventShowCaseMapComponent
];

@NgModule({
  declarations: [
    RebusApp,
    // Pipes
    GroupByPipe,
    OrderByPipe,
    sanitizeHtmlPipe,
    TranslatePipe,
    hackPipe,
    languagesPipe,
    TruncatePipe,
    ...PAGES_COMPONENTS
  ],
  imports: [
    BrowserModule,
    HttpModule,
    JsonpModule,
    Ionic2RatingModule,
    ChartsModule,
    // scrollAssist: false or true
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [Http]
      }
    }),
    // Api google maps integration
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyDQt72FWXZeor7Sm6mBHC-GM9IbSGGfk8I'
    }),
    IonicStorageModule.forRoot(),
    IonicModule.forRoot(RebusApp, {}, {
      links: [
        {component: LandingPage, name:'Landing', segment:'app/:url'},
        // {component: EventPage, name:'Event', segment:'event'},
        // {component: LoginPage, name:'Login', segment:'login'},
        // {component: EventNotesPage, name:'Notes', segment:'event_note'},
        // {component: EventQuestionsPage, name:'Questions', segment:'evetn_questions'},
        // {component: EventOpinometerPage, name:'Opinometer', segment:'evetn_opinometer'},
        // {component: EventDiaryPage, name:'EventDiary', segment:'event_diary', defaultHistory:[EventPage]},
        // {component: ClientPage, name:'Client', segment:'client'},
        // {component: EventSpeakerPage, name:'EventSpeaker', segment:'event_speaker', defaultHistory:[EventPage]},
        // {component: HomePage, name:'Home', segment:'home'},
       ]
    }),
    AngularFireModule.initializeApp(firebaseGlobalConfig, FirebaseAuthConfig)
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    RebusApp,
    ...PAGES_COMPONENTS
  ],
  providers: [
    AuthData,
    ClientData,
    EventData,
    NotesData,
    QuestionsData,
    DiaryData,
    UserData,
    Utilities,
    Tracking,
    Database,
    StorageFb,
    SpeakerData,
    ReserveData,
    Translate,
  ]
})
export class AppModule {}
// end file



// WEBPACK FOOTER //
// ./src/app/app.module.ts